export const NAME_REGEX = /^[a-zA-Z\-'.\s]{0,50}$/;
export const NAME_WITH_DIGITS_REGEX = /^[a-zA-Z0-9\-'.\s]{0,50}$/;
export const PHONE_NUMBER_REGEX = /^\+?[0-9\s().-]{0,20}$/;
